import React, { useEffect, useState } from "react";
import Table from "react-bootstrap/Table";
import Pagination from "react-bootstrap/Pagination";
import { formatDate, getArticleName } from "common/FunctionUtils";

export const MonthlySummary = ({ filterData, t }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  const currentItems = filterData?.slice(startIndex, endIndex);
  const totalPages = Math.ceil(filterData?.length / itemsPerPage);

  useEffect(() => {
    setCurrentPage(1);
  }, [filterData]);

  const items = [];
  for (let number = 1; number <= totalPages; number++) {
    items?.push(
      <Pagination.Item
        key={number}
        active={number === currentPage}
        onClick={() => handlePageChange(number)}
      >
        {number}
      </Pagination.Item>
    );
  }

  return (
    <div className="mt-4 p-3">
      <h6>
        <span className="font-weight-bold">
          {t("Selected month calendar summary")}
        </span>
      </h6>

      <Table responsive="sm" size="sm">
        <thead>
          <tr style={{ backgroundColor: "#5d47b6" }}>
            <th style={{ color: "white" }}>{t("Serial No.")}</th>
            <th style={{ color: "white" }}>{t("User Id")}</th>
            <th style={{ color: "white" }}>{t("Date")}</th>
            <th style={{ color: "white" }}>{t("Description")}</th>
            <th style={{ color: "white" }}>{t("Hours")}</th>
            <th style={{ color: "white" }}>{t("Invoice No")}</th>
          </tr>
        </thead>
        <tbody>
          {currentItems?.length ? (
            currentItems?.map((item, index) => (
              <tr key={item?.id}>
                <td>{startIndex + index + 1}</td>
                <td>{item?.userId}</td>
                <td>
                  {t(formatDate(item?.workingDate)?.split(" ")[0])}{" "}
                  {formatDate(item?.workingDate)?.split(" ")[1]}{" "}
                  {formatDate(item?.workingDate)?.split(" ")[2]}{" "}
                </td>
                <td>{t(getArticleName(item?.articleNumber))}</td>
                <td>{item?.number}</td>
                <td>{item?.invoiceNumber}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={6} className="text-center">
                <p className="text-dark p-3">{t("No data found")}</p>
              </td>
            </tr>
          )}
        </tbody>
      </Table>

      {filterData?.length > 15 && (
        <div className="paginationInvoice">
          <Pagination style={{ flexWrap: "wrap" }}>{items}</Pagination>
          <br />
        </div>
      )}
    </div>
  );
};
